(function(){
function init(root){
  if(root.dataset.fx) return;
  var grid=root.querySelector('[data-grid]'),rm=root.querySelector('[data-ring-main]'),ring=root.querySelector('[data-ring]');
  if(!grid||!rm||!ring||!grid.children.length) return;
  root.dataset.fx='1';
  var st=ring.querySelectorAll('linearGradient stop'); if(st.length>1){ st[0].setAttribute('stop-color','#B36BFF'); st[1].setAttribute('stop-color','#FF8FC7'); }
  if('IntersectionObserver' in window){ new IntersectionObserver(function(e){ document.body.classList.toggle('gbm-on',e[0].isIntersecting); },{threshold:.05}).observe(root); }
  var order=[];
  grid.addEventListener('click',function(){
    setTimeout(function(){
      var on=[].filter.call(grid.children,function(c){return c.getAttribute('aria-pressed')==='true'});
      order=order.filter(function(c){return on.indexOf(c)>-1});
      on.forEach(function(c){ if(order.indexOf(c)<0) order.push(c); });
      [].forEach.call(grid.children,function(c){ var i=order.indexOf(c); if(i>-1) c.setAttribute('data-n',i+1); else c.removeAttribute('data-n'); });
      try{ if(navigator.vibrate) navigator.vibrate(10); }catch(e){}
    },0);
  });
  var last=parseInt(rm.textContent,10)||0;
  new MutationObserver(function(){
    var v=parseInt(rm.textContent,10)||0;
    root.classList.toggle('is-full',v>=25);
    if(v>last&&v>0) burst();
    last=v;
  }).observe(rm,{childList:true,characterData:true,subtree:true});
  function burst(){
    var cols=['#FF8FC7','#B36BFF','#7FB6FF','#8CE6C8','#FFB48A'];
    for(var i=0;i<18;i++){
      var s=document.createElement('i'); s.className='gbm__cf';
      var a=Math.PI*2*i/18+Math.random()*.4, d=46+Math.random()*34;
      s.style.cssText='--dx:'+Math.round(Math.cos(a)*d)+'px;--dy:'+Math.round(Math.sin(a)*d)+'px;--r:'+Math.round(Math.random()*360)+'deg;--s:'+(6+Math.round(Math.random()*5))+'px;--c:'+cols[i%5];
      ring.appendChild(s); setTimeout(function(x){x.remove()},1000,s);
    }
  }
}
function boot(){ [].forEach.call(document.querySelectorAll('[data-gbm]'),init); }
document.addEventListener('DOMContentLoaded',boot); window.addEventListener('load',function(){boot();setTimeout(boot,800)});
if(document.readyState!=='loading') boot();
})();